import React, { useState } from 'react'

const initialFormData = {
  name: '',
  email: '',
  subject: '',
  phone: '',
  message: '',
  country: ''
}

const AppProposalForm = ({
  serviceTitle = 'App Development',
  eyebrow = 'SEND YOUR',
  heading,
  submitLabel = 'Send Message'
}) => {
  const [formData, setFormData] = useState(initialFormData)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [formLoader, setFormLoader] = useState(false)
  const [formError, setFormError] = useState('')

  const updateField = (field) => (event) => {
    setFormData((current) => ({ ...current, [field]: event.target.value }))
  }

  const submitMessage = async (event) => {
    event.preventDefault()
    setFormLoader(true)
    setFormError('')

    try {
      const response = await fetch('https://formsubmit.co/ajax/metatech674@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          _subject: `New ${serviceTitle} query from Metatech`,
          Name: formData.name,
          Email: formData.email,
          Contact: formData.phone,
          Country: formData.country,
          Subject: formData.subject,
          Message: formData.message,
          Service: serviceTitle,
          _template: 'box'
        })
      })

      if (!response.ok) {
        throw new Error('Unable to submit your message right now.')
      }

      setFormSubmitted(true)
    } catch (error) {
      setFormError(error.message || 'Unable to submit your message right now.')
    } finally {
      setFormLoader(false)
    }
  }

  return (
    <section className="container py-5 text-light" aria-labelledby="app-proposal-heading">
      <h2 className="h5 fw-bold text-center" style={{}}>
        {eyebrow}
      </h2>
      <div className="row justify-content-center">
        <div className="col-12 col-md-7">
          <div className="d-flex justify-content-center text-center">
            <h2 id="app-proposal-heading" className="display-4 my-4">
              {heading || `Free ${serviceTitle} Proposal`}
            </h2>
          </div>
          <form onSubmit={submitMessage}>
            <fieldset disabled={formLoader || formSubmitted} className="border-0 p-0 m-0">
              <input
                required
                onChange={updateField('name')}
                value={formData.name}
                name="Name"
                type="text"
                className="form-control rounded-4 p-3"
                autoComplete="name"
                placeholder="Enter your name"
              />
              <div className="d-flex flex-column flex-md-row">
                <input
                  required
                  onChange={updateField('email')}
                  value={formData.email}
                  name="email"
                  type="email"
                  className="form-control rounded-4 p-3 my-2 me-md-2"
                  autoComplete="email"
                  placeholder="Enter Your Email"
                />
                <input
                  required
                  onChange={updateField('phone')}
                  value={formData.phone}
                  name="number"
                  type="tel"
                  className="form-control rounded-4 p-3 my-2"
                  autoComplete="tel"
                  placeholder="Phone Number"
                />
              </div>
              <div className="d-flex flex-column flex-md-row">
                <input
                  required
                  onChange={updateField('country')}
                  value={formData.country}
                  name="country"
                  type="text"
                  className="form-control rounded-4 p-3 my-2 me-md-2"
                  autoComplete="country-name"
                  placeholder="Country"
                />
                <input
                  required
                  onChange={updateField('subject')}
                  value={formData.subject}
                  name="subject"
                  type="text"
                  className="form-control rounded-4 p-3 my-2"
                  placeholder="Subject"
                />
              </div>
              <textarea
                required
                onChange={updateField('message')}
                value={formData.message}
                name="Message"
                placeholder="Your Question"
                className="form-control rounded-4 p-3 my-2"
                rows="4"
              />
            </fieldset>

            <div className="py-3 d-flex justify-content-center">
              <button
                disabled={formLoader || formSubmitted}
                className={`btn btn-${formSubmitted ? 'success' : 'primary'} rounded-4 p-3 d-flex align-items-center`}
                type="submit"
              >
                {formSubmitted ? 'Submitted' : submitLabel}
                {formLoader && (
                  <span className="spinner-border spinner-border-sm text-light ms-2" role="status">
                    <span className="visually-hidden">Sending message...</span>
                  </span>
                )}
              </button>
            </div>

            {formSubmitted && (
              <p className="h4 text-success text-center" role="status">
                Thanks for sending us a proposal. Our team will get back to you shortly.
              </p>
            )}
            {formError && <p className="text-danger text-center" role="alert">{formError}</p>}
          </form>
        </div>
      </div>
    </section>
  )
}

export default AppProposalForm
